<template>
 <div>
 <div class="row">
   <div class="col-7">
  <ul class="sideul nav">
    <li class="sideli back" @click="getplist()">
      <i class="fa fa-angle-left"></i>
      <a>{{pname}}</a> 
    </li>
    <li v-for="(v,i) in list" :class="{sideli:true,active:index==i}" @click="select(v,i)" :key="v.title">
      <i class="fa fa-angle-left" v-show="v.back"></i>
      <a :class="{active:index==i}">{{v.title}}</a>
      <i class="fa fa-angle-right" v-show="v.child"></i>
    </li>
  </ul>
  </div>
  <div class="col-3" @click="hide"></div>
 </div>
</div> 
</template>

<style scoped>
/*导航*/
.row{position: relative;z-index: 888;height:100%;}
.col-7{height:100%;padding:0;}
.col-3{background: rgb(250,250,250);opacity: .5;height: 100%;}
.sideul{
  float: left;
  list-style: none;
  padding-left: 0;
  background: rgb(250,250,250);
  height: 100%;
  width:100%;
 /* position:fixed;
  z-index: 999;
  top:0;*/
}
.sideli{
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ddd;
    font-size: 1.2rem;
    color:rgb(173,173,173);
    position: relative;
}
.sideul .active{
  color:rgb(0,144,255);
  background: white;
}
.sideli a{ color:rgb(173,173,173);text-decoration-line: none;padding-left: 2rem;}
.sideli a.active{color:rgb(0,144,255);}
.sideli .fa-angle-left{position: absolute;left:1rem;top:1rem;}
.sideli .fa-angle-right{position: absolute;right:1rem;top:1rem;}

.back{background: #f0f7ff;}


/*--导航*/
</style>

<script>
import Vue from "vue"
import VueRouter from "vue-router"

const router = new VueRouter();

export default{
  name:"sidenav",
  props:{
    delist:{type:Array},
  },
  data:function(){
  	return {
    list:this.delist,
    plist:[],
    pname:"回到首页",
    index:"",
    mydata:mydata,
  	};
  },
  methods:{
    select:function(v,i){
      this.index=i;
      //this.mydata.nav=v.title;
      if(!v.child||v.child.length==0){
        this.$router.push({path: v.href});
        this.mydata.navshow=false;
      }else{
        this.plist=this.list;
        this.pname=v.title;
        this.list=v.child;
      }
    },
    getplist:function(){
      if(this.plist.length==0){
        this.mydata.navshow=false;
        mydata.nav="/";
        this.$router.push({path: '/'});
       }else{
         this.list=this.plist;
         this.plist=[]; 
         this.pname="回到首页";
      }  
    },
    hide:function(){
       this.mydata.navshow=false;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/lib/sidenav.vue